const base64UrlParaTexto = (valor) => {
  const base64 = String(valor || "")
    .replace(/-/g, "+")
    .replace(/_/g, "/");
  const padding = base64.length % 4;
  const normalizado = padding ? base64 + "=".repeat(4 - padding) : base64;
  return decodeURIComponent(
    Array.prototype.map
      .call(atob(normalizado), (c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );
};

export const obterExpiracaoTokenMs = (token) => {
  try {
    const partes = String(token || "").split(".");
    if (partes.length !== 3) return null;

    const payload = JSON.parse(base64UrlParaTexto(partes[1]));
    const exp = Number(payload?.exp);

    if (!Number.isFinite(exp) || exp <= 0) return null;
    return exp * 1000;
  } catch (_) {
    return null;
  }
};

export const sessaoValida = (dataUser, agoraMs = Date.now()) => {
  if (!dataUser || !dataUser.token) return false;

  const expiraEm = obterExpiracaoTokenMs(dataUser.token);

  // Os logins atuais da Telemetria usam JWT com expiração.
  // Se o token estiver inválido/corrompido, não deixa o painel abrir.
  if (!expiraEm) return false;

  return expiraEm > agoraMs;
};
